<template>
  <div class="ma-5">
    <v-data-table
      :headers="headers"
      :items="parceiras"
      :loading="carregando"
      class="elevation-3"
      hide-default-footer
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Instâncias Parceiras</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="abrirNovo">
            <v-icon left>mdi-plus</v-icon>
            Nova Parceira
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.ativo="{ item }">
        <v-icon v-if="item.ativo" color="green">mdi-check-circle</v-icon>
        <v-icon v-else color="grey">mdi-close-circle-outline</v-icon>
      </template>

      <template v-slot:item.action="{ item }">
        <v-icon class="mr-2" title="Editar" @click="editar(item)">mdi-pencil</v-icon>
        <v-icon class="mr-2" title="Testar conexão" @click="testarItem(item)">mdi-lan-connect</v-icon>
        <v-icon title="Remover" color="red" @click="remover(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" persistent max-width="640px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ editedItem.id ? 'Editar' : 'Nova' }} Instância Parceira</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="6" class="pa-2">
                <v-text-field
                  v-model="editedItem.nome"
                  label="Nome*"
                  outlined
                  dense
                  :error-messages="nomeErrors"
                  @input="$v.editedItem.nome.$touch()"
                  @blur="$v.editedItem.nome.$touch()"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pa-2">
                <v-text-field
                  v-model.number="editedItem.timeout_seg"
                  label="Timeout (segundos)*"
                  outlined
                  dense
                  type="number"
                  min="1"
                  max="30"
                  :error-messages="timeoutErrors"
                  @input="$v.editedItem.timeout_seg.$touch()"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pa-2">
                <v-text-field
                  v-model.trim="editedItem.url_base"
                  label="URL base (http(s)://...)*"
                  outlined
                  dense
                  hint="Ex.: https://equipe2.pesquisa.click/api-infoguest/public — ou http://localhost:8000/api-infoguest/public no loopback"
                  persistent-hint
                  :error-messages="urlErrors"
                  @input="$v.editedItem.url_base.$touch()"
                  @blur="$v.editedItem.url_base.$touch()"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pa-2">
                <v-text-field
                  v-model="editedItem.token_servico"
                  :label="editedItem.id ? 'Token de serviço (deixe em branco para manter)' : 'Token de serviço*'"
                  outlined
                  dense
                  :type="mostrarToken ? 'text' : 'password'"
                  :append-icon="mostrarToken ? 'mdi-eye' : 'mdi-eye-off'"
                  hint="Mínimo 32 caracteres. Deve ser idêntico nas duas instâncias."
                  persistent-hint
                  :error-messages="tokenErrors"
                  @click:append="mostrarToken = !mostrarToken"
                  @input="$v.editedItem.token_servico.$touch()"
                  @blur="$v.editedItem.token_servico.$touch()"
                ></v-text-field>
                <div class="d-flex align-center mt-1">
                  <v-btn
                    small
                    text
                    color="primary"
                    @click="gerarToken"
                  >
                    <v-icon left small>mdi-key-variant</v-icon>
                    Gerar token (64 chars)
                  </v-btn>
                  <v-btn
                    small
                    text
                    :disabled="!editedItem.token_servico"
                    @click="copiarToken"
                  >
                    <v-icon left small>mdi-content-copy</v-icon>
                    Copiar
                  </v-btn>
                  <span v-if="tokenCopiado" class="caption green--text ml-2">
                    Copiado para a área de transferência.
                  </span>
                </div>
              </v-col>
              <v-col cols="12" class="pa-2">
                <v-switch
                  v-model="editedItem.ativo"
                  label="Ativa"
                  hide-details
                ></v-switch>
              </v-col>
              <v-col cols="12" v-if="resultadoTeste.tipo">
                <v-alert
                  :type="resultadoTeste.ok ? 'success' : (resultadoTeste.tipo === 'token' ? 'error' : 'warning')"
                  dense
                  text
                >
                  {{ resultadoTeste.mensagem }}
                </v-alert>
              </v-col>
            </v-row>
          </v-container>
          <small>* Indica Campos Obrigatórios</small>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="grey darken-1" @click="testarConexao" :disabled="!editedItem.url_base">
            <v-icon left>mdi-lan-connect</v-icon>
            Testar conexão
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="fechar">Sair</v-btn>
          <v-btn color="primary" text @click="salvar">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import ParceiraAPI from "./../../api/parceira";

const httpsUrl = (v) => {
  if (!v) return true;
  const s = String(v).trim();
  return /^https?:\/\//i.test(s);
};
const tokenMin = (vm) => (v) => {
  // Em edição: token vazio = manter
  if (vm.editedItem.id && (!v || v.length === 0)) return true;
  return !!v && v.length >= 32;
};

export default {
  name: "CfgInstanciaParceira",

  data: () => ({
    parceiras: [],
    carregando: false,
    dialog: false,
    mostrarToken: false,
    tokenCopiado: false,
    resultadoTeste: { ok: false, tipo: "", mensagem: "" },
    headers: [
      { text: "ID", value: "id", width: 60 },
      { text: "Nome", value: "nome" },
      { text: "URL", value: "url_base" },
      { text: "Timeout", value: "timeout_seg", width: 90 },
      { text: "Ativa", value: "ativo", width: 80, align: "center" },
      { text: "Ações", value: "action", sortable: false, width: 140, align: "center" },
    ],
    editedItem: {
      id: 0,
      nome: "",
      url_base: "",
      token_servico: "",
      ativo: false,
      timeout_seg: 5,
    },
    defaultItem: {
      id: 0,
      nome: "",
      url_base: "",
      token_servico: "",
      ativo: false,
      timeout_seg: 5,
    },
  }),

  validations() {
    return {
      editedItem: {
        nome: { required },
        url_base: { required, httpsUrl },
        token_servico: { tokenMin: tokenMin(this) },
        timeout_seg: { required },
      },
    };
  },

  computed: {
    nomeErrors() {
      const errs = [];
      if (!this.$v.editedItem.nome.$dirty) return errs;
      !this.$v.editedItem.nome.required && errs.push("Campo obrigatório.");
      return errs;
    },
    urlErrors() {
      const errs = [];
      if (!this.$v.editedItem.url_base.$dirty) return errs;
      !this.$v.editedItem.url_base.required && errs.push("Campo obrigatório.");
      !this.$v.editedItem.url_base.httpsUrl && errs.push("URL deve começar com http(s)://");
      return errs;
    },
    tokenErrors() {
      const errs = [];
      if (!this.$v.editedItem.token_servico.$dirty) return errs;
      !this.$v.editedItem.token_servico.tokenMin && errs.push("Token deve ter no mínimo 32 caracteres.");
      return errs;
    },
    timeoutErrors() {
      const errs = [];
      if (!this.$v.editedItem.timeout_seg.$dirty) return errs;
      const v = Number(this.editedItem.timeout_seg);
      if (!v || v < 1 || v > 30) errs.push("Use entre 1 e 30 segundos.");
      return errs;
    },
  },

  watch: {
    dialog(val) {
      if (!val) this.fechar();
    },
  },

  created() {
    this.carregar();
  },

  methods: {
    carregar() {
      this.carregando = true;
      const headers = this.Helpers.iniciarRequisicao();
      ParceiraAPI.getCfg(headers)
        .then((response) => {
          this.parceiras = response.data.parceiras || [];
        })
        .catch((error) => {
          if (error.response && error.response.status === 403) {
            this.Helpers.exibirMensagem("Acesso restrito a administradores.", "error", 5000);
          } else {
            this.Helpers.exibirMensagem("Falha ao carregar parceiras.", "error", 4000);
          }
        })
        .finally(() => {
          this.carregando = false;
          this.$store.dispatch("loading/habilitarLoading", false);
        });
    },

    abrirNovo() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.resultadoTeste = { ok: false, tipo: "", mensagem: "" };
      this.dialog = true;
    },

    editar(item) {
      this.editedItem = {
        id: item.id,
        nome: item.nome,
        url_base: item.url_base,
        token_servico: "",
        ativo: !!item.ativo,
        timeout_seg: item.timeout_seg,
      };
      this.resultadoTeste = { ok: false, tipo: "", mensagem: "" };
      this.dialog = true;
    },

    fechar() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.resultadoTeste = { ok: false, tipo: "", mensagem: "" };
        this.$v.$reset();
      }, 200);
    },

    salvar() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const headers = this.Helpers.iniciarRequisicao();
      const payload = {
        id: this.editedItem.id,
        nome: this.editedItem.nome,
        url_base: this.editedItem.url_base,
        token_servico: this.editedItem.token_servico,
        ativo: this.editedItem.ativo,
        timeout_seg: this.editedItem.timeout_seg,
      };

      ParceiraAPI.salvarCfg(headers, payload)
        .then(() => {
          this.Helpers.exibirMensagem("Configuração salva.", "success", 3000);
          this.fechar();
          this.carregar();
        })
        .catch((error) => {
          const err = error.response && error.response.data && error.response.data.error;
          const msg = err === "token_muito_curto"
            ? "Token muito curto (mínimo 32 caracteres)."
            : err === "url_invalida"
            ? "URL inválida."
            : err === "campos_obrigatorios"
            ? "Preencha todos os campos obrigatórios."
            : err === "sem_permissao"
            ? "Acesso restrito a administradores."
            : "Falha ao salvar.";
          this.Helpers.exibirMensagem(msg, "error", 5000);
        });
    },

    testarConexao() {
      const headers = this.Helpers.getHeaderRequisicao();
      const payload = {
        id: this.editedItem.id || 0,
        url_base: this.editedItem.url_base,
        token_servico: this.editedItem.token_servico,
      };
      this.resultadoTeste = { ok: false, tipo: "loading", mensagem: "Testando..." };

      ParceiraAPI.testarCfg(headers, payload)
        .then((response) => {
          this.resultadoTeste = {
            ok: !!response.data.ok,
            tipo: response.data.tipo || "ok",
            mensagem: response.data.mensagem || "Resultado recebido.",
          };
        })
        .catch(() => {
          this.resultadoTeste = {
            ok: false,
            tipo: "rede",
            mensagem: "Falha ao chamar o backend para testar.",
          };
        });
    },

    testarItem(item) {
      this.editar(item);
      // Aguarda dialog abrir e dispara teste
      setTimeout(() => this.testarConexao(), 200);
    },

    gerarToken() {
      const bytes = new Uint8Array(32);
      window.crypto.getRandomValues(bytes);
      const hex = Array.from(bytes)
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
      this.editedItem.token_servico = hex;
      this.mostrarToken = true;
      this.$v.editedItem.token_servico.$touch();
      // Já tenta copiar — economiza um clique
      this.copiarToken();
    },

    copiarToken() {
      const v = this.editedItem.token_servico || "";
      if (!v) return;
      const finalizar = () => {
        this.tokenCopiado = true;
        setTimeout(() => {
          this.tokenCopiado = false;
        }, 3000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(v)
          .then(finalizar)
          .catch(() => {
            this.copiarFallback(v);
            finalizar();
          });
      } else {
        this.copiarFallback(v);
        finalizar();
      }
    },

    copiarFallback(valor) {
      const ta = document.createElement("textarea");
      ta.value = valor;
      ta.setAttribute("readonly", "");
      ta.style.position = "absolute";
      ta.style.left = "-9999px";
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand("copy");
      } catch (e) {
        // silencioso — usuário pode copiar manualmente
      }
      document.body.removeChild(ta);
    },

    remover(item) {
      if (!confirm(`Remover a parceira "${item.nome}"?`)) return;
      const headers = this.Helpers.iniciarRequisicao();
      ParceiraAPI.removerCfg(headers, item.id)
        .then(() => {
          this.Helpers.exibirMensagem("Parceira removida.", "success", 3000);
          this.carregar();
        })
        .catch(() => {
          this.Helpers.exibirMensagem("Falha ao remover.", "error", 4000);
        });
    },
  },
};
</script>
<style scoped>
</style>
